import { create } from 'zustand'

export const useThemeStore = create((set) => ({
  darkMode: false,
  sidebarOpen: false,
  
  toggleDarkMode: () => set((state) => ({ darkMode: !state.darkMode })),
  setSidebarOpen: (open) => set({ sidebarOpen: open }),
  toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen }))
}))

export const useCartStore = create((set, get) => ({
  items: [],
  total: 0,
  
  addItem: (product) => {
    const items = get().items
    const existingItem = items.find(item => item.id === product.id)
    
    if (existingItem) {
      set({
        items: items.map(item =>
          item.id === product.id
            ? { ...item, quantity: item.quantity + 1 }
            : item
        )
      })
    } else {
      set({
        items: [...items, { ...product, quantity: 1 }]
      })
    }
    
    get().calculateTotal()
  },
  
  removeItem: (productId) => {
    set({
      items: get().items.filter(item => item.id !== productId)
    })
    get().calculateTotal()
  },
  
  updateQuantity: (productId, quantity) => {
    if (quantity <= 0) {
      get().removeItem(productId)
      return
    }
    
    set({
      items: get().items.map(item =>
        item.id === productId
          ? { ...item, quantity }
          : item
      )
    })
    get().calculateTotal()
  },
  
  calculateTotal: () => {
    const total = get().items.reduce((sum, item) => sum + (item.price * item.quantity), 0)
    set({ total })
  },
  
  clearCart: () => set({ items: [], total: 0 })
}))

export const useNotificationStore = create((set) => ({
  notifications: [],
  
  addNotification: (notification) => {
    const id = Date.now()
    set({
      notifications: [...get().notifications, { id, ...notification }]
    })
    
    // Auto remove after 5 seconds
    setTimeout(() => {
      get().removeNotification(id)
    }, 5000)
  },
  
  removeNotification: (id) => {
    set({
      notifications: get().notifications.filter(n => n.id !== id)
    })
  },
  
  clearNotifications: () => set({ notifications: [] })
}))
